import React, { useEffect, useState, useRef } from "react";
import IconMenu from "../../components/subMenu/SubMenu";
import { useParams, useNavigate } from "react-router-dom";
import useSave from "../../Hooks/useSave";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Button, Paper, TextField } from "@mui/material";
import { Box } from "@mui/system";
import { PDFViewer } from "@react-pdf/renderer";
import PricelistReportPDF from "./PricelistReportPDF"; // adjust path as needed

export default function PricelistReport() {
  const [pricelist, setPricelist] = useState({
    pricelistName: "",
    percentChange: null,
  });
  const [products, setProducts] = useState([]);
  const [pricelistExceptions, setPricelistExceptions] = useState([]);
  const [open, setOpen] = useState(false);

  const name = useRef();

  const navigate = useNavigate();
  const { fetchGraphql, DialogSave } = useSave();

  useEffect(() => {
    fetchGraphql({
      query: `
          query Products($pricelistId: ID) {
              pricelist(pricelistId: $pricelistId) {
              pricelistId
              pricelistName
              percentChange
            }
            products(pricelistId: $pricelistId) {
              productId
              productCode
              productName
              productDescription
              productPrice
              priceByPound
              productCategory
              productSubCategory
              productUnitOfMeasure
              productAmount
              groupId
              groupCode
              productionSheet
              sortOrder
            }
          }`,
      variables: {
        pricelistId: id,
      },
    }).then((result) => {
      console.log(result.data.products);
      setProducts(result.data.products);
      setPricelist(result.data.pricelist);
    });
  }, []);

  const { id } = useParams();

  console.log(id);

  const menuHeaderPricelist = {
    icon: "",
    name: `Pricelist ${pricelist.pricelistName}`,
  };

  const menuPricelist = [
    {
      link: `/products/pricelists/pricelist/${id}`,
      path: "/pricelist/:id",
      name: "Pricelist",
    },
    {
      link: `/products/pricelists/pricelist/report/${id}`,
      path: "/pricelist/report/:id",
      name: "Report",
    },
  ];

  return (
    <>
      <IconMenu menuHeader={menuHeaderPricelist} menu={menuPricelist} />
      <DialogSave />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Box
        sx={{ display: "flex", flexDirection: "column", width: "100%", ml: 2 }}
      >
        <Button
          sx={{ margin: "0px auto 20px 0px", marginRight: "auto" }}
          variant="outlined"
          onClick={() => navigate("/products/pricelists")}
          id="back"
        >
          <ArrowBackIcon />
          Back
        </Button>
        <Box sx={{ width: "100%", height: "100%" }}>
          <PDFViewer width="100%" height="900px" style={{ border: "none" }}>
            <PricelistReportPDF pricelist={pricelist} products={products} />
          </PDFViewer>
        </Box>
      </Box>
    </>
  );
}
